<div class="container-fluid markets-detail">

  <div [hidden]="signal">

    <div class="row d-flex align-items-center mt-0">
      <div class="col-1">
        <span class="text-left detail-link" backButton><i class="icon-edponline-Bra-078 rotate-180 font-size-32"></i></span>
      </div>
      <div class="col-8 offset-1 d-flex justify-content-center">
        <span class="detail-text">{{'edp.emarket.detalhe.produto' | translate}}</span>
      </div>
    </div>

    <div class="row d-flex justify-content-center detail-product-name mt-4">
      {{ market.nm | marketName }}<span>{{ market.nm | marketInfo }}</span>
    </div>

    <div class="row d-flex justify-content-center mt-3">
      <ul class="nav nav-pills price-volume">
        <li class="nav-item price-volume-options" (click)="chartComp.changeUnitsGraph('price')" id="change-price-volume">
          <a class="d-flex align-items-center justify-content-center nav-link text-center active" data-toggle="pill" href="#dia">
            <span>{{'edp.emarket.detalhe.preco' | translate}}</span>
          </a>
        </li>
        <li class="spacer d-none"></li>
        <li class="nav-item price-volume-options d-none">
          <span class="d-flex align-items-center justify-content-center nav-link text-center">
            <span>{{'edp.emarket.detalhe.volume' | translate}}</span>
          </span>
        </li>
      </ul>
    </div>

    <div class="row line"></div>

    <div class="row d-flex px-4 pb-3 pt-4">
      <div class="col-12 px-0">
        <ul class="d-flex nav nav-tabs countries justify-content-start">
          @for (marketCt of marketCountriesName; track marketCt; let i = $index) {
            <li class="d-flex pr-2 pr-sm-4">
              <a class="nav-link text-center px-0 d-flex flex-column cursor-pointer" [ngClass]="{'active': marketCountry === marketCt }" data-toggle="pill"
                (click)="chartComp.setCountry(marketCountriesLink[i])" id="market-country">
                {{ 'edp.emarket.signaling.' + (marketCt | lowercase) | translate }}
              </a>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 px-4">
        <span class="label">{{'edp.emarket.detalhe.zoom' | translate}}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-9 col-lg-7 col-xl-4 pills px-4 mb-4">
        <ul class="nav nav-pills border">
          <li class="nav-item" (click)="chartComp.setDayZoom()" id="nav-item-day">
            <a class="d-flex align-items-center justify-content-center nav-link text-center" data-toggle="pill" href="#dia">
              <span>{{'edp.emarket.detalhe.dia' | translate}}</span>
            </a>
          </li>
          <li class="nav-item" (click)="chartComp.setMonthZoom()" id="nav-item-month">
            <a class="d-flex align-items-center justify-content-center nav-link text-center active" data-toggle="pill" href="#mes">
              <span>{{'edp.emarket.detalhe.mes' | translate}}</span>
            </a>
          </li>
          <li class="nav-item" (click)="chartComp.setYearZoom()" id="nav-item-year">
            <a class="d-flex align-items-center justify-content-center nav-link text-center" data-toggle="pill" href="#ano">
              <span>{{'edp.emarket.detalhe.ano' | translate}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <div class="chart-background pt-4 mx-2">
        <span class="chart-unities pl-2">{{ market.vu }}</span>
      </div>
      <app-highchart #chartComp (minValue)="setMinValue($event)" (maxValue)="setMaxValue($event)"></app-highchart>
    </div>

    <div class="row">
      <div class="col-12 px-4 mt-4">
        <div class="d-flex justify-content-between">
          <div class="">
            <span class="min-max">{{'edp.emarket.detalhe.min.max' | translate}}</span>
          </div>
          <div class="">
            <span class="detail-value omip-color">{{ minValue }} - {{ maxValue }} </span>
            <span class="detail-currency">{{ market.vu }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col px-4 d-flex align-content-start">
        <span class="min-max-text">
          {{'edp.emarket.detalhe.valor.min.max.cotacao' | translate}}
        </span>
      </div>
    </div>

    @if (userFlag >= 1) {
      <div class="row mt-3 mb-5">
        <div class="col-12 offset-md-3 col-md-6 col-xl-4 offset-xl-4 px-4">
          @if (market.sc === 'OMIP') {
            <button class="btn bg w-100" (click)="setSignal()" id="btn-signal">
              <span class="bg-text">{{'edp.emarket.detalhe.sinalizar' | translate}}</span>
            </button>
          }
        </div>
      </div>
    }

  </div>

  @if (!submit) {
    <div [hidden]="!signal">
      <div class="row d-flex align-items-center mt-md-2 my-4 mx-md-0">
        <div class="col-1">
          <span class="text-left" (click)="cancel()" id="cancel">
            <i class="icon-edponline-Bra-073 rotate-90 font-size-24"></i>
          </span>
        </div>
        <div class="col-8 offset-1 d-flex justify-content-center">
          <span class="product-detail-text">{{'edp.emarket.detalhe.produto' | translate}}</span>
        </div>
      </div>
      <div class="row">
        @if (market.sc === 'OMIP' && userFlag >= 1) {
          <div class="col-12 d-flex justify-content-center signal-product">
            <span>{{'edp.emarket.detalhe.sinalizar' | translate}}</span>
            <span class="pl-2">{{ market.nm }}</span>
          </div>
        }
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <form [formGroup]="newSignalingForm" (ngSubmit)="onSubmit()" class="px-2">
            <div class="form-group px-2">
              <label for="valor">
                {{'edp.emarket.detalhe.valor' | translate}}
              </label>
              <input type="text" class="form-control" formControlName="signalValue" [pattern]="numberOnly" placeholder="%" id="form-signalValue">
              @if (f.signalValue.errors && f.signalValue.errors.pattern) {
                <div class="pl-3 form-label text-danger">
                  {{'edp.emarket.detalhe.valor.casas.decimais' | translate}}
                </div>
              }
              <button class="btn bg w-100 mt-4" type="submit" id="btn-submit">
                <span class="bg-text">{{'edp.emarket.detalhe.avancar' | translate}}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  }

  @if (submit) {
    <div>
      <div class="row d-flex align-items-center mt-md-2 my-4">
        <div class="col-1">
          <span class="text-left" backButton><i class="icon-edponline-Bra-073 rotate-90 font-size-24"></i></span>
        </div>
        <div class="col-8 offset-1 d-flex justify-content-center">
          <span class="detail-text">{{'edp.emarket.detalhe.produto' | translate}}</span>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="signal-confirm">
          <span class="d-block">{{'edp.emarket.detalhe.confirmar.sinalizacao' | translate}} {{ f.signalValue.value }}% {{'edp.emarket.detalhe.contrato' | translate}}</span>
          <span>{{marketName}}</span>
          <span>?</span>
        </div>
      </div>
      <div class="row px-4 pt-4 margin-top-33">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
          <button class="btn bg w-100" (click)="confirm()" id="btn-confirm">
            <span class="bg-text">{{'edp.emarket.detalhe.confirmar' | translate}}</span>
          </button>
        </div>
      </div>
      <div class="row mt-3 px-4">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
          <button class="btn bg-2 w-100" (click)="cancel()" id="btn-cancel">
            <span class="bg-text">{{'edp.emarket.detalhe.cancelar' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  }
</div>
